import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ApiResponse } from '../../../interfaces/api-response';
import { ConnectServerService } from '../../../services/connect-server.service';

interface InventoryArtisticArticle {
  id: number;
  title: string;
}

interface InventoryArtisticGroup {
  title: string;
  isOpen: boolean;
  listArticles: InventoryArtisticArticle[];
}

@Component({
  selector: 'app-inventory-artistic',
  imports: [],
  templateUrl: './inventory-artistic.component.html',
  styleUrl: './inventory-artistic.component.scss',
})
export class InventoryArtisticComponent implements OnInit {

  inventoryArtistic: InventoryArtisticGroup[] = [];
  hasLoaded = false;

  private readonly connectServerService = inject(ConnectServerService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.getInventoryArtistic();
  }

  get totalArticles(): number {
    return this.inventoryArtistic.reduce((sum, group) => sum + group.listArticles.length, 0);
  }

  toggleGroup(group: InventoryArtisticGroup): void {
    if (!group.listArticles.length) {
      return;
    }
    group.isOpen = !group.isOpen;
  }

  goToArticle(id: number): void {
    this.router.navigate(['archivioArtistico/scheda', id]);
  }

  private getInventoryArtistic(): void {
    this.connectServerService.getRequest<ApiResponse<{ artisticalInventory: InventoryArtisticGroup[] }>>('inventoryArtistic', {})
      .subscribe((val: ApiResponse<{ artisticalInventory: InventoryArtisticGroup[] }>) => {
        this.inventoryArtistic = (val.data?.artisticalInventory ?? []).map((group: InventoryArtisticGroup) => ({
          ...group,
          isOpen: false,
          listArticles: group.listArticles ?? [],
        }));
        this.hasLoaded = true;
      });
  }

}
